import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Link from "next/link";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import { Icon, InteractionLayer, Typography } from "@bookips/sds";
/**
 * 안내 배너 컴포넌트
 * - 클릭 시 해당 URL로 이동하거나 onClick 핸들러 실행
 * - InteractionLayer (variant="light") 적용
 */ export const GuideBanner = (param)=>{
    let { className , text , href , onClick , bannerId  } = param;
    // MX-357: 가이드 배너 클릭 핸들러
    const handleClick = ()=>{
        mixpanelEvent("Guide Button Clicked", {
            "Button URL": href || "",
            "Button Name": text,
            ID: bannerId || "",
            Position: "Edition Category"
        });
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    const content = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-1 items-center gap-1.5",
                children: [
                    /*#__PURE__*/ _jsx(Icon.Info_2px, {
                        className: "size-4 shrink-0 text-primary"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "body2",
                        className: "flex-1 break-words text-primary",
                        children: text
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Icon.ArrowRight_2px, {
                className: "size-4 shrink-0 text-gray-700"
            })
        ]
    });
    const wrapperClassName = cn("flex w-full items-start gap-2 rounded-md bg-gray-0 px-4 py-3", className);
    if (href) {
        return /*#__PURE__*/ _jsx(InteractionLayer, {
            as: Link,
            href: href,
            variant: "light",
            className: wrapperClassName,
            onClick: handleClick,
            children: content
        });
    }
    return /*#__PURE__*/ _jsx(InteractionLayer, {
        variant: "light",
        onClick: handleClick,
        className: wrapperClassName,
        children: content
    });
};
